export const imageCardSurfaceSx = {
  height: "100%",
  width: "100%",
  p: 2,
  boxShadow: "0 2px 4px rgba(0,0,0,0.5)",
  position: "relative",
};

export const imageCardImageFrameSx = {
  position: "relative",
  width: "100%",
  pb: "100%",
  background: "#fff",
};

export const imageCardTextSectionSx = {
  borderTop: "2px solid #e0e0e0",
};
